export default "__VITE_ASSET__300949f5__"